import { motion } from 'motion/react';
import { Quote, Star } from 'lucide-react';
import { useTranslation } from '../i18n';

const testimonials = [
  {
    clientKey: 'sarahLi',
    image: 'https://images.unsplash.com/photo-1738566061688-47e66a008254?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMGFzaWFufGVufDF8fHx8MTc2NTA3NTM5OHww&ixlib=rb-4.1.0&q=80&w=1080',
  },
  {
    clientKey: 'davidZhang',
    image: 'https://images.unsplash.com/photo-1756009531697-51da316bfa3a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGluZXNlJTIwcHJvZmVzc2lvbmFsJTIwc21pbGluZ3xlbnwxfHx8fDE3NjUwNzUzOTh8MA&ixlib=rb-4.1.0&q=80&w=1080',
  },
  {
    clientKey: 'jenniferWang',
    image: 'https://images.unsplash.com/photo-1589114207353-1fc98a11070b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRhbnQlMjBwcm9mZXNzaW9uYWx8ZW58MXx8fHwxNzY0OTk5NDI5fDA&ixlib=rb-4.1.0&q=80&w=1080',
  },
];

export function Testimonials() {
  const { t } = useTranslation();
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-[#0A1A33] mb-4 text-[36px]">{t('testimonials.section.title')}</h2>
          <p className="text-gray-600 mb-2">{t('testimonials.section.subtitle')}</p>
          <p className="text-[#C6A667]">{t('testimonials.section.tagline')}</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.clientKey}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote className="w-10 h-10 text-[#C6A667]/30" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#C6A667] text-[#C6A667]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 mb-6 leading-relaxed">{t(`testimonials.clients.${testimonial.clientKey}.quote`)}</p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <img
                  src={testimonial.image}
                  alt={t(`testimonials.clients.${testimonial.clientKey}.name`)}
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div>
                  <p className="text-[#0A1A33]">{t(`testimonials.clients.${testimonial.clientKey}.name`)}</p>
                  <p className="text-xs text-[#C6A667] mt-1">
                    {t(`testimonials.clients.${testimonial.clientKey}.role`)} · {t(`testimonials.clients.${testimonial.clientKey}.location`)}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
